import React, { useState, useEffect } from "react";
import "./Home.css";
import "../../medicalequipments/MedicalEquipments.css";
import { Link } from "react-router-dom"; //Link
import { fetchAPI } from "../../utils/api";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import { ShimmerThumbnail, ShimmerTitle, ShimmerButton } from "react-shimmer-effects";

function ProductCard({ equipment }) {
  const rentalOptions = equipment.attribute || [];
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(0);

  const currentAttr = rentalOptions[selectedAttrIndex] || null;
  const displayPrice = currentAttr ? currentAttr.price : (equipment.me_security_amount || "0");

  const handleOptionClick = (e, idx) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAttrIndex(idx);
  };

  return (
    <Link to={`/product/${equipment.me_slug || equipment.me_id}`} state={{ product: equipment, selectedAttrIndex, selectedAttrId: currentAttr?.attribute_value_id, selectedAttribute: currentAttr }}>
      <div className="equip-box">
        {equipment.me_category === "1" && (
          <span className="badge">Bestseller</span>
        )}

        <div className="eqip-img">
          <img
            src={equipment.me_image || "/placeholder.png"}
            alt={equipment.me_product_name}
            className="img-fluid"
          />
        </div>

        <div className="equipment_content">
          <label>{equipment.me_product_name}</label>

          <div className="star_review">
            <div className="stars">
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
              <StarPurple500OutlinedIcon />
            </div>

            <p className="starpera">
              <span> 4.8 </span>
            </p>
          </div>
          <div className="days-booking">
            <p>Rent : </p>
            {rentalOptions.map((opt, idx) => (
              <span
                key={opt.attribute_value_id}
                onClick={(e) => handleOptionClick(e, idx)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: selectedAttrIndex === idx ? '#13baac' : '#ffffff',
                  borderColor: selectedAttrIndex === idx ? '#13baac' : '#d7d7d7',
                  color: selectedAttrIndex === idx ? '#ffffff' : 'var(--dark-grey)',
                  userSelect: 'none'
                }}
              >
                {opt.attribute_value}
              </span>
            ))}
          </div>
          <div className="price-divider"></div>

          <div className="price-row">
            <div className="medicine-price">
              <span className="sale-price">
                ₹{displayPrice}
                {currentAttr && currentAttr.attribute_value ? (
                  <span style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginLeft: '3px', textTransform: 'lowercase' }}>
                    / {currentAttr.attribute_value.toLowerCase()}
                  </span>
                ) : '/-'}
              </span>
            </div>
            <button className="medicine-add-btn">
              Add
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
}

function Product({ homeSettings = {} }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const title = (homeSettings.home_medicine_title && homeSettings.home_medicine_title.trim() !== '') ? homeSettings.home_medicine_title : "Products on Rent";
  const description = (homeSettings.home_medicine_description && homeSettings.home_medicine_description.trim() !== '') ? homeSettings.home_medicine_description : "Compassionate nursing care, physiotherapy, and bedside assistance tailored for patient comfort, recovery, and daily healthcare support.";
  const link = (homeSettings.home_medicine_link && homeSettings.home_medicine_link.trim() !== '') ? homeSettings.home_medicine_link : "/product-on-rent";

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await fetchAPI("EquipmentsController/products", {
          method: "POST",
          body: JSON.stringify({}),
        });
        if (data && data.status === 200) {
          setProducts(data.result || []);
        }
      } catch (error) {
        console.error("Error fetching dynamic products in home:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <div className="products_section">
        <div className="container-fluid">
          <div className="section_heading row align-items-center mb-4">
            <div className="text_part col-lg-6 col-sm-8 col-6">
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
          </div>
          <div className="row g-3">
            {[1, 2, 3, 4].map((item) => (
              <div key={item} className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                <div 
                  className="equip-box p-3" 
                  style={{ 
                    background: "#ffffff", 
                    borderRadius: "12px", 
                    border: "1px solid #f0f0f0",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
                  }}
                >
                  <ShimmerThumbnail height={170} rounded className="mb-3" />
                  <ShimmerTitle line={1} gap={10} variant="primary" />
                  <ShimmerTitle line={1} gap={10} variant="secondary" />
                  <div className="d-flex justify-content-between align-items-center mt-3 pt-2" style={{ borderTop: "1px solid #f5f5f5" }}>
                    <div style={{ width: "45%" }}>
                      <ShimmerTitle line={1} gap={0} variant="primary" />
                    </div>
                    <ShimmerButton size="sm" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const displayProducts = products.slice(0, 8);

  if (displayProducts.length === 0) {
    return null;
  }

  return (
    <>
      <div className="products_section">
        <div className="container-fluid">
          <div className="section_heading row align-items-center">
            <div className="text_part col-lg-6 col-sm-8 col-6">
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
            <div className="btn_part col-lg-6 col-sm-4 col-6 text-end">
              <button className="main_btn">
                <Link to={link}>
                  View All <ArrowForwardIosIcon />
                </Link>
              </button>
            </div>
          </div>
          <div className="slider-wrapper">
            <Swiper
              key={displayProducts.length}
              modules={[Autoplay, Navigation]}
              spaceBetween={30}
              slidesPerView={Math.min(4, displayProducts.length)}
              navigation
              loop={false}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: Math.min(2, displayProducts.length),
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: Math.min(3, displayProducts.length),
                  spaceBetween: 15,
                },
                1024: {
                  slidesPerView: Math.min(4, displayProducts.length),
                  spaceBetween: 15,
                },
              }}
            >
              {displayProducts.map((equipment) => (
                <SwiperSlide key={equipment.me_id}>
                  <ProductCard equipment={equipment} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
}

export default Product;

